// permissions/webRoutes.js
export const WEB_ROUTES = [
  { path: "/shifts", capability: "schedule" },
  { path: "/employees", capability: "employees" },
  { path: "/projects", capability: "projects" },
  { path: "/project-overview", capability: "projects" },
  { path: "/project-groups", capability: "projects" },
  { path: "/reports", capability: "reports" },
  { path: "/customers", capability: "customers" },

  { path: "/analysis-portal", capability: "schedule" },

  { path: "/payroll", capability: "payroll" },
  { path: "/ob-overview", capability: "payroll" },
  { path: "/absence-overview", capability: "payroll" },
  { path: "/overtime-overview", capability: "payroll" },
  { path: "/export-payroll", capability: "payroll" },

  { path: "/overtime-requests", capability: "cases" },
  { path: "/absence-requests", capability: "cases" },

  { path: "/business", capability: "settings" },
  { path: "/role-information", capability: "settings" },
  { path: "/subscription", capability: "settings" },
];
